import { AxiosError } from "axios";

export function formatAPIError(err: unknown, fallback = "Произошла ошибка"): string {
  const ax = err as AxiosError<unknown>;
  const data = ax?.response?.data as
    | { error?: unknown; detail?: unknown; message?: unknown }
    | undefined;
  if (data) {
    // Стандартная форма ginerr: { error: { code, message } }
    const errObj = data.error;
    if (errObj && typeof errObj === "object" && "message" in errObj) {
      const m = (errObj as { message?: unknown }).message;
      if (typeof m === "string" && m) return m;
    }
    // Нестандартные формы (старый 500 и т.п.): { detail }, { error: "строка" }, { message }
    if (typeof data.detail === "string" && data.detail) return data.detail;
    if (typeof data.error === "string" && data.error) return data.error;
    if (typeof data.message === "string" && data.message) return data.message;
  }
  // Сетевая ошибка / таймаут — даём осмысленный текст вместо «Произошла ошибка».
  if (ax?.message && !ax.response) return ax.message;
  return fallback;
}

// Централизованные query keys для invalidation
export const qk = {
  users: (filters?: Record<string, unknown>) => ["users", filters] as const,
  user: (id: string) => ["user", id] as const,
  roles: () => ["roles"] as const,
  role: (id: string) => ["role", id] as const,
  permissions: () => ["permissions"] as const,
  companies: (filters?: Record<string, unknown>) => ["companies", filters] as const,
  company: (id: string) => ["company", id] as const,
  audit: (filters?: Record<string, unknown>) => ["audit", filters] as const,
  me: () => ["me"] as const,
  clients: (filters?: Record<string, unknown>) => ["clients", filters] as const,
  client: (id: string) => ["client", id] as const,
  clientContacts: (clientId: string) => ["clientContacts", clientId] as const,
  carriers: (filters?: Record<string, unknown>) => ["carriers", filters] as const,
  carrier: (id: string) => ["carrier", id] as const,
  carrierContacts: (carrierId: string) => ["carrierContacts", carrierId] as const,
  drivers: (filters?: Record<string, unknown>) => ["drivers", filters] as const,
  driver: (id: string) => ["driver", id] as const,
  vehicles: (filters?: Record<string, unknown>) => ["vehicles", filters] as const,
  vehicle: (id: string) => ["vehicle", id] as const,
  vehicleDrivers: (vehicleId: string) => ["vehicleDrivers", vehicleId] as const,
  bodyTypes: () => ["bodyTypes"] as const,
  contracts: (entityType: string, entityId: string) => ["contracts", entityType, entityId] as const,
  orders: (filters?: Record<string, unknown>) => ["orders", filters] as const,
  order: (id: string) => ["order", id] as const,
  orderStatuses: () => ["order-statuses"] as const,
  orderAudit: (id: string) => ["orderAudit", id] as const,
  orderLoadingPoints: (id: string) => ["orderLoadingPoints", id] as const,
  orderUnloadingPoints: (id: string) => ["orderUnloadingPoints", id] as const,
  orderCargo: (id: string) => ["orderCargo", id] as const,
  orderServicesClient: (id: string) => ["orderServicesClient", id] as const,
  orderServicesCarrier: (id: string) => ["orderServicesCarrier", id] as const,
};
